import { ColumnDef } from '@tanstack/react-table';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Divider, Text } from 'theme-ui';
import DataTable from '../../../Tabels/Tabel';
import { setPagination } from '../../../../store/actions/Pagination.action';
import { getAllStagesMasterData } from '../../../../store/actions/masterData.action';
import { useDispatch } from 'react-redux';
import { TabelHeadingTxt } from '../../../Text/TabelCommonTxt';
import plus from "../../../assets/images/Icon/plus.svg";
import { useNavigate } from 'react-router-dom';
import TableActions from '../../users/TableActions';

const StagesMasteData: React.FC = () => {
    const navigate = useNavigate();
    const { stagelist, loader } = useSelector((state: any) => state.masterData);
    const { paginations } = useSelector((state: any) => state.pagination);
    const [refresh, setRrefresh] = useState<boolean>(true);
    const dispatch = useDispatch();
    const columns = useMemo<ColumnDef<any>[]>(() => [
        // {
        //     accessorKey: "id",
        //     enableColumnFilter: false,
        //     id: "select",
        //     header: ({ table }) => (
        //         <div className="d-flex justify-content-center">
        //             <IndeterminateCheckbox
        //                 {...{
        //                     checked: table.getIsAllRowsSelected(),
        //                     indeterminate: table.getIsSomeRowsSelected(),
        //                     onChange: table.getToggleAllRowsSelectedHandler(),
        //                 }}
        //             />
        //         </div>
        //     ),
        //     cell: ({ row }) => (
        //         <IndeterminateCheckbox
        //             {...{
        //                 checked: row.getIsSelected(),
        //                 disabled: !row.getCanSelect(),
        //                 indeterminate: row.getIsSomeSelected(),
        //                 onChange: row.getToggleSelectedHandler(),
        //             }}
        //         />
        //     ),
        // },
        {
            header: 'No',
            enableColumnFilter: false,
            accessorKey: "no",
            cell: ({ row }) => {
                return (
                    <Text variant='Poppins14Normal24lh'>{((paginations?.currentPage - 1) * paginations?.limit) + row?.index + 1}</Text>
                )
            }
        },
        {
            accessorKey: "name",
            header: 'Name',
            cell: info => info.getValue(),
        },
        {
            header: 'Description',
            accessorKey: "description",
            cell: info => info.getValue(),
        },
        {
            header: 'Color',
            accessorKey: "color",
            cell: ({ row }) => {
                return (
                    <div className='d-flex justify-content-center'>
                        <Box sx={{ border: "2px solid black", width: "40%", borderRadius: 40, justifyContent: 'center', borderColor: row?.original?.color, backgroundColor: row?.original?.color, color: row?.original?.color, padding: "10px" }} className="text-center d-flex"></Box>
                    </div>
                )
            }

        },
        {
            header: 'Accessor',
            accessorKey: "Accessor",
            enableColumnFilter: false,
            cell: ({ row }) => {
                return (
                    <TableActions row={row} editTo={`/edit-stage/${row?.original?._id}`} deleteMessage='Are you sure you want to delete this stage?' deleteApi={`stages/delete-stages/${row?.original?._id}`} toggleRefresh={() => setRrefresh(true)} />
                )
            },
        }
    ], [stagelist?.data]);

    useEffect(() => {
        return () => {
            dispatch(setPagination({
                limit: 15,
                currentPage: 1,
            }))
        }
    }, [])
    useEffect(() => {
        if (refresh) {
            dispatch(getAllStagesMasterData(paginations))
            setRrefresh(false)
        }
    }, [refresh])

    const handleclick = () => {
        navigate("/create-stage")
    }
    return (
        <div className='main-content'>
            <TabelHeadingTxt Title='Stage' Count={stagelist?.count || 15} BtnTxt='Create Stage' src={plus} onClick={handleclick} sx={{ backgroundColor: '#7743DB', color: 'white' }} />
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <DataTable
                loader={loader}
                columns={columns}
                data={stagelist?.data || []}
                TotalLength={stagelist?.count || 15}
                perPageCount={paginations.limit}
                currentPage={paginations.currentPage}
                onPerPageChange={(itemsPerPage) => {
                    dispatch(setPagination({
                        limit: itemsPerPage,
                        currentPage: 1
                    }));
                    setRrefresh(true);
                }}
                onPageChange={(value) => {
                    dispatch(setPagination({
                        ...paginations,
                        ...{ currentPage: value }
                    }));
                    setRrefresh(true);
                }} />
        </div>
    )
};

export default StagesMasteData;
